var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanternLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 494,
    viewBox: "0 0 1800 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.3 297.1V149.1H592.1V315.8H682.3L691 297.1H614.3Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 146.3L724.1 315.8H747.7L763.9 278.8H838.2L854.6 315.8H878.2L801.3 146.3H801ZM772.1 260.5C783.4 235 792 215.1 801.3 191.5C810.3 215.1 818.9 235 830.2 260.5H772.1Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.9 264.4L1034.6 258.6L931.1 146.3H930.8V315.8H953.1V200.5L958.4 206.3L1061.9 318.6H1062.1V149.1H1039.9V264.4Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.9 167.9H1169.6V315.8H1191.8V167.9H1243.7V149.1H1117.9V167.9Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.7 240.8H1390.3V222H1321.7V167.9H1402.8V149.1H1299.5V315.8H1406.3V297.1H1321.7V240.8Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.5 200C1585.5 168 1563.5 149.1 1526.9 149.1H1468V315.8H1490.2V250.5H1529.9L1564.4 315.8H1589.2L1551.5 246.8C1569.3 241.3 1585.5 225.1 1585.5 200ZM1528.1 232.2H1490.3V167.8H1526.3C1549.5 167.8 1563.3 179.8 1563.3 200C1563.3 220.2 1550.1 232.2 1528.1 232.2Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.2 146.3H1652.9V315.8H1675.2V200.5L1680.5 206.3L1784 318.6H1784.2V287.8L1653.2 146.3Z",
    fill: "#00675B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.2 213.8L1768.5 178L1784.2 142.2L1800 178L1784.2 213.8Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.9 217.3L391 266.7L427.4 300.2L428.2 250.8L391.9 217.3Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.4 289.1L364.8 331.9L381.8 377.2L404.3 334.4L387.4 289.1Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.5 350.8L312.9 378.2L307.7 425.2L346.3 397.8L351.5 350.8Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.8 389.3L247.1 396.8L222.3 435.9L268 428.4L292.8 389.3Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.3 398L178.1 384.3L139.2 407.4L182.3 421.1L221.3 398Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 372.6L120.7 341.4L76.5 344L107.9 375.2L152 372.6Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.6 320.7L89.5998 279.8L49.7998 263L63.6998 303.9L103.6 320.7Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6997 252.2L88.2997 210.4L60.7997 178.4L55.1997 220.2L82.6997 252.2Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8 178.5L119.5 144.9L110.1 104.8L86.5 138.5L95.8 178.5Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.4 120.7L174.8 101.7L184.2 62.7002L148.8 81.7002L139.4 120.7Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 88.5L242.6 87.1L267.6 57L228.5 58.4L203.5 88.5Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.8 88.3004L312.3 104.6L347.4 89.7004L312.9 73.4004L277.8 88.3004Z",
    fill: "#FFAE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.5 391.7L460.8 353L442.1 315.8L426.8 354.5L445.5 391.7Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.9 398.5L358.4 425.4L358.1 466.1L388.7 439.2L388.9 398.5Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.5 448.3L266.9 458.3L248.7 493.7L287.2 483.7L305.5 448.3Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 456.1L171.9 448.2L140.6 471.4L178.7 479.3L210 456.1Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.3 420L88.7002 396.2L51.2002 402.4L80.8002 426.3L118.3 420Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3996 345.1L36.4996 311.1L1.09961 299.6L16.0996 333.6L51.3996 345.1Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9 251.6L27.6 215.4L1.7 190L0 226.2L25.9 251.6Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9 155.5L61.3 124.7L49.9 91.2002L32.5 122L43.9 155.5Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 74.3L135 55.6L140.3 21.5L111.3 40.2L106 74.3Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.8 30.9998L228.2 27.5998L247.9 0.299805L214.5 3.6998L194.8 30.9998Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.7 31.0994L323.4 42.5994L352.4 27.3994L321.7 15.8994L292.7 31.0994Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.7 76.1996L404.9 99.9996L436.8 99.8996L415.6 76.0996L383.7 76.1996Z",
    fill: "#FF7F02"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.1 195L330.7 223.3L358.9 234.3L348.3 206L320.1 195Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.6 237.7L330.6 267.3L350.7 289.3L353.7 259.6L333.6 237.7Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.4 281.5L310.1 305.7L317.3 334.1L333.7 309.9L326.4 281.5Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.8 315.5L274.7 329.8L268.7 358L293.8 343.7L299.8 315.5Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259 334.2L230.7 336.3L213.5 358.9L241.8 356.7L259 334.2Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.2 333.1L187.4 322.6L162.3 334.8L188.2 345.4L213.2 333.1Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.8 312.5L156.5 292L129 292.1L147.3 312.5H174.8Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.5 276.8L142.1 250.8L117.9 239L125.2 265L149.5 276.8Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.2 231.6L148.4 205.6L132.4 184.4L127.2 210.4L143.2 231.6Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.8 190L173.7 169.3L168.8 143.7L152.9 164.4L157.8 190Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.1 159.8L212 148.3L218.6 123.5L195.7 135.1L189.1 159.8Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232 146.7H257.2L273.9 127.9H248.7L232 146.7Z",
    fill: "#FFD800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 494,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanternLogoLight);
export default __webpack_public_path__ + "static/media/lantern-logo-light.29bd30102949af86d527cc53d3f8b066.svg";
export { ForwardRef as ReactComponent };